import { biomeFloorSamplePoint } from './biome-floor-sampling';
const WIDTH=96, HEIGHT=48;
type Pixel={offset:number;weights:Float64Array;samples:Uint16Array};
let stencil:readonly Pixel[]|undefined;
/** Shared full-precision geometry for all already oriented material frames. */
function geometry():readonly Pixel[]{
 if(stencil)return stencil;
 const pixels:Pixel[]=[];
 const smooth=(distance:number)=>{const value=Math.max(0,Math.min(1,1-distance/12));return .5*value*value*(3-2*value);};
 for(let y=0;y<HEIGHT;y++)for(let x=0;x<WIDTH;x++){
  const px=x+.5,py=y+.5;
  if(Math.abs(px-48)/48+Math.abs(py-24)/24>1)continue;
  const normal=Math.sqrt(5),distances=[(48-px+2*py)/normal,(144-px-2*py)/normal,(px-2*py+48)/normal,(px+2*py-48)/normal];
  const [ne,se,sw,nw]=distances.map(smooth) as [number,number,number,number];
  const weights=new Float64Array([(1-ne)*(1-se)*(1-sw)*(1-nw),ne*(1-nw)*(1-se),se*(1-ne)*(1-sw),sw*(1-se)*(1-nw),nw*(1-ne)*(1-sw),ne*se,se*sw,sw*nw,nw*ne]);
  const samples=new Uint16Array(9);
  for(let i=0;i<9;i++){
   const [sampleX,sampleY]=biomeFloorSamplePoint(i,px,py,distances);
   const sx=Math.max(0,Math.min(WIDTH-1,Math.round(sampleX-.5))),sy=Math.max(0,Math.min(HEIGHT-1,Math.round(sampleY-.5)));
   samples[i]=(sy*WIDTH+sx)*4;
  }
  pixels.push({offset:(y*WIDTH+x)*4,weights,samples});
 }
 return stencil=pixels;
}
/** Byte-equivalent diamond composition without recomputing distances and reflected samples. */
export function blendBiomeFloorPixels(frames:readonly {data:Uint8ClampedArray}[]):Uint8ClampedArray{
 const output=new Uint8ClampedArray(WIDTH*HEIGHT*4);
 for(const {offset,weights,samples} of geometry()){
  let alpha=0,red=0,green=0,blue=0;
  for(let i=0;i<9;i++){
   const weight=weights[i]!;if(!weight)continue;
   const pixel=samples[i]!,data=frames[i]!.data,a=data[pixel+3]!/255*weight;
   alpha+=a;red+=data[pixel]!*a;green+=data[pixel+1]!*a;blue+=data[pixel+2]!*a;
  }
  const center=frames[0]!.data;
  output[offset]=alpha>0?red/alpha:center[offset]!;
  output[offset+1]=alpha>0?green/alpha:center[offset+1]!;
  output[offset+2]=alpha>0?blue/alpha:center[offset+2]!;
  output[offset+3]=255;
 }
 return output;
}
